import script from "./FoodLogView.vue?vue&type=script&setup=true&lang=js"
export * from "./FoodLogView.vue?vue&type=script&setup=true&lang=js"

import "./FoodLogView.vue?vue&type=style&index=0&id=1128d942&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1128d942"]])

export default __exports__